import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { get } from '../../../services/apiController';
import { toast } from 'react-toastify';
import OrderForm from './OrderForm';

const OrderEditModal = ({ show, closeModal, orderId, productId, fetchOrders }) => {
  const [shapes, setShapes] = useState([]);
  const [flavours, setFlavours] = useState([]);
  const [product, setProduct] = useState();

  useEffect(() => {
    get(`/cake/products/${productId}`)
      .then((res) => {
        const { data } = res;
        setProduct(data);
        setFlavours(data?.flavours);
        setShapes(data?.shapes);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [productId]);
  return (
    <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header>
        <Modal.Title>Update Order Details</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
      </Modal.Header>
      <Modal.Body style={{ fontFamily: 'auto' }}>
        <OrderForm
          productId={productId}
          product={product}
          shapes={shapes}
          flavours={flavours}
          orderId={orderId}
          callback={() => {
            closeModal();
            fetchOrders();
          }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default OrderEditModal;
